module.exports = __webpack_public_path__ + "img/can.8d3f0f2e.png";